import ReusableFooter from "../UI/ReusableFooter";

export default function EmployeeFooter({
  list,
  total,
  perPage,
  setCurrentPage,
  currentPage,
}) {
  return (
    <ReusableFooter
      total={total}
      itemPerPage={perPage}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
    />
  );
}
